import React, { useEffect,useContext } from "react";
import Context from '../context/context';
import Spinner from '../spinner/spinner';
import ReactGA from 'react-ga4';



export default function Find(user) {
   
    const  context = useContext(Context)
    
    useEffect(() => { 
       
       // ReactGA.pageview('/offer', "Offer Page Signup")
	},[]);


    const data = [
       {
            screenName: 'ojitosdulces7',
            age: 39,
            id: '761799',
    
        },
        {
            screenName: 'leireouch',
            age: 30,
            id: '761715',
    
        },
        {
            screenName: 'placerxplacer9 ',
            age: 22,
            id: '761749',
    
        },
		 {
            screenName: 'ociopoquito',
            age: 28,
            id: '760207',
    
        },
		
        {
            screenName: 'picarona4',
            age: 25,
            id: '760229',
    
        },
        {
            screenName: 'glorieraglory',
            age: 37,
            id: '761913',
    
        },
		
        
        {
            screenName: 'juguetitto9',
            age: 33,
            id: '761921',
    
        },
        {
            screenName: 'hermosssura8',
            age: 29,
            id: '761835',
    
        },
        {
            screenName: 'luni8',
            age: 21,
            id: '761635',
    
        },
        {
            screenName: 'nenita3buena9',
            age: 56,
            id: '761769',
    
        },
        {
            screenName: 'virynena',
            age: 24,
            id: '761535',
    
        },
        {
            screenName: '3piscineeraa3',
            age: 27,
            id: '761765',
    
        },
        {
            screenName: '6aventurera7',
            age: 49,
            id: '761585',
    
        },
        {
            screenName: 'luiissa',
            age: 41,
            id: '761479',
    
        },
        {
            screenName: 'disfrutalavida9',
            age: 38,
            id: '761749',
    
        },
        {
            screenName: 'maitepeli0rroja',
            age: 49,
            id: '761391',
    
        },
        {
            screenName: '5aventurera5',
            age: 40,
            id: '761379',
    
        },
        {
            screenName: 'muchasganasxxx',
            age: 52,
            id: '761345',
    
        },
        {
            screenName: 'rubitaloquita',
            age: 51,
            id: '761281',
    
        },
       
    ];

    function NumberAdd(str){
	
	
		var strArr = str.num.id[0].split("");
	
		if(strArr[3] % 2){
			return(<span><i className="fab fa-whatsapp" style={{color:`#25D366`}}/></span>);
		}else{
			return(<span><i className="fab fa-whatsapp" style={{color:`#25D366`}}/><i className="fab fa-facebook-messenger" style={{color:`#0076FE`}}></i></span>);
		}
		
	}

	return (  <div className="container-find bg-light">
    
    <div className="containerFullWidth" role="main">
       <div id="userlist" className="row no-gutters ultra_blurred">

       <div>
		  <ul> 
			{data.map(el => (
				<div className="col-6 col-sm-4 col-md-4 col-lg-2 p-1 d-inline-block p-resp" key={el.id}>
					<div className="card card-search-page">
						
						<img className="card-img-top" src={process.env.REACT_APP_CDN+"/es/"+el.id+".jpg"} alt={el.screenName} />  
						
					   <div className="bottomPhoto" ><NumberAdd num={el} /><span>{el.screenName}</span></div>
					</div>
				</div>
			))}
		  </ul>
		 
	
		 
		
		</div>
           
       </div>
        <div className="row no-gutters">
            <div className="col-12 text-center pb-3 pt-3">
                <div id="loader_pagination"><i className="fas fa-circle-notch fa-spin"></i></div>
            </div>
        </div>
    </div>
</div>);


}